import { Form, Space } from 'antd';
import FormSelect from 'components/form/FormSelect';
import { CardWrapper } from 'containers/TransferOrder/Show/styles';
import React from 'react';
import AddressLabel from './AddressLabel';
import { get } from 'lodash';
import { useSelector } from '@redux';
import { DynamicObjectType } from 'types/commons';

const RightContent = ({ isEdit }: { isEdit?: boolean }) => {
  const user = useSelector<DynamicObjectType>((state) => state.auth.data);

  return (
    <Space className="w-full" size={20} direction="vertical">
      <CardWrapper title="From Warehouse">
        <Form.Item
          noStyle
          shouldUpdate={(p, c) =>
            get(p, 'toWarehouseId') !== get(c, 'toWarehouseId') ||
            get(p, 'orderSelected') !== get(c, 'orderSelected')
          }
        >
          {({ getFieldValue }) => {
            const toWarehouseId = getFieldValue('toWarehouseId');
            const orderSelected = getFieldValue('orderSelected');

            if (user?.locationCode?.split(',').length > 0) {
              return isEdit ? (
                !!toWarehouseId && (
                  <FormSelect
                    reference={{
                      labelProp: 'abc',
                      model: `locations`,
                      searchKey: 'name',
                      valueProp: 'id',
                      allowClear: true,
                      labelFormat: (item) => (
                        <div>
                          {item?.name
                            ? `${item?.name} | ${item?.code}`
                            : item?.code}
                        </div>
                      ),
                      initFilters: {
                        filters: [
                          {
                            condition: 'and',
                            key: 'id',
                            operator: 'in',
                            value: user?.locationCode?.split(',') || [],
                          },
                          ...(toWarehouseId
                            ? [
                                {
                                  condition: 'and',
                                  key: 'id',
                                  operator: 'ne',
                                  value: toWarehouseId,
                                } as any,
                              ]
                            : []),
                          ...(orderSelected?.[0]?.orderType === 'TAB_TRY_BUY'
                            ? [
                                {
                                  condition: 'and',
                                  key: 'isTabTryBuy',
                                  operator: 'ne',
                                  value: true,
                                } as any,
                              ]
                            : []),
                        ],
                      },
                      dependency: toWarehouseId,
                    }}
                    name="fromWarehouseId"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter From Warehouse',
                      },
                    ]}
                    placeholder="Select"
                  />
                )
              ) : (
                <FormSelect
                  reference={{
                    labelProp: 'abc',
                    model: `locations`,
                    searchKey: 'name',
                    valueProp: 'id',
                    allowClear: true,
                    labelFormat: (item) => (
                      <div>
                        {item?.name
                          ? `${item?.name} | ${item?.code}`
                          : item?.code}
                      </div>
                    ),
                    initFilters: {
                      filters: [
                        {
                          condition: 'and',
                          key: 'id',
                          operator: 'in',
                          value: user?.locationCode?.split(',') || [],
                        },
                        ...(toWarehouseId
                          ? [
                              {
                                condition: 'and',
                                key: 'id',
                                operator: 'ne',
                                value: toWarehouseId,
                              } as any,
                            ]
                          : []),
                        ...(orderSelected?.[0]?.orderType === 'TAB_TRY_BUY'
                          ? [
                              {
                                condition: 'and',
                                key: 'isTabTryBuy',
                                operator: 'ne',
                                value: true,
                              } as any,
                            ]
                          : []),
                      ],
                    },
                    dependency: toWarehouseId,
                  }}
                  name="fromWarehouseId"
                  rules={[
                    { required: true, message: 'Please enter From Warehouse' },
                  ]}
                  placeholder="Select"
                />
              );
            } else {
              return isEdit ? (
                !!toWarehouseId && (
                  <FormSelect
                    reference={{
                      labelProp: 'abc',
                      model: `locations`,
                      searchKey: 'name',
                      valueProp: 'id',
                      allowClear: true,
                      labelFormat: (item) => (
                        <div>
                          {item?.name
                            ? `${item?.name} | ${item?.code}`
                            : item?.code}
                        </div>
                      ),
                      initFilters: {
                        filters: [
                          {
                            condition: 'and',
                            key: 'id',
                            operator: 'in',
                            value: [],
                          },
                          ...(toWarehouseId
                            ? [
                                {
                                  condition: 'and',
                                  key: 'id',
                                  operator: 'ne',
                                  value: toWarehouseId,
                                } as any,
                              ]
                            : []),
                          ...(orderSelected?.[0]?.orderType === 'TAB_TRY_BUY'
                            ? [
                                {
                                  condition: 'and',
                                  key: 'isTabTryBuy',
                                  operator: 'ne',
                                  value: true,
                                } as any,
                              ]
                            : []),
                        ],
                      },
                      dependency: toWarehouseId,
                    }}
                    name="fromWarehouseId"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter From Warehouse',
                      },
                    ]}
                    placeholder="Select"
                  />
                )
              ) : (
                <FormSelect
                  reference={{
                    labelProp: 'abc',
                    model: `locations`,
                    searchKey: 'name',
                    valueProp: 'id',
                    allowClear: true,
                    labelFormat: (item) => (
                      <div>
                        {item?.name
                          ? `${item?.name} | ${item?.code}`
                          : item?.code}
                      </div>
                    ),
                    initFilters: {
                      filters: [
                        {
                          condition: 'and',
                          key: 'id',
                          operator: 'in',
                          value: [],
                        },
                        ...(toWarehouseId
                          ? [
                              {
                                condition: 'and',
                                key: 'id',
                                operator: 'ne',
                                value: toWarehouseId,
                              } as any,
                            ]
                          : []),
                        ...(orderSelected?.[0]?.orderType === 'TAB_TRY_BUY'
                          ? [
                              {
                                condition: 'and',
                                key: 'isTabTryBuy',
                                operator: 'is',
                                value: true,
                              } as any,
                            ]
                          : []),
                      ],
                    },
                    dependency: toWarehouseId,
                  }}
                  name="fromWarehouseId"
                  rules={[
                    { required: true, message: 'Please enter From Warehouse' },
                  ]}
                  placeholder="Select"
                />
              );
            }
          }}
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prevValues, curValues) =>
            prevValues.fromWarehouseId !== curValues.fromWarehouseId
          }
        >
          {({ getFieldValue }) => {
            return (
              getFieldValue('fromWarehouseId') && (
                <AddressLabel locationId={getFieldValue('fromWarehouseId')} />
              )
            );
          }}
        </Form.Item>
      </CardWrapper>
      <CardWrapper title="To Warehouse">
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, curValues) =>
            prevValues.orderSelected !== curValues.orderSelected
          }
        >
          {({ getFieldsValue }) => {
            return (
              <FormSelect
                reference={{
                  labelProp: 'name',
                  model: `locations`,
                  searchMoreKeys: ['name', 'code'],
                  valueProp: 'id',
                  allowClear: true,
                  labelFormat: (item) => (
                    <div>
                      {item?.name
                        ? `${item?.name} | ${item?.code}`
                        : item?.code}
                    </div>
                  ),
                  operator: 'contL',
                  disabled: !!getFieldsValue().toWarehouseId,
                }}
                name="toWarehouseId"
                rules={[
                  { required: true, message: 'Please enter To Warehouse' },
                ]}
                placeholder="Select"
              />
            );
          }}
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prevValues, curValues) =>
            prevValues.toWarehouseId !== curValues.toWarehouseId
          }
        >
          {({ getFieldValue }) => {
            return (
              getFieldValue('toWarehouseId') && (
                <AddressLabel locationId={getFieldValue('toWarehouseId')} />
              )
            );
          }}
        </Form.Item>
      </CardWrapper>
    </Space>
  );
};

export default RightContent;
